// @flow
import { routerView } from "@uniflowed/router";

export default routerView("./app");
